export * from './bn-registration-header-v2.module';
export * from './bn-registration-header-v2.component';